import type { NextPage } from 'next';
import styles from './Header.module.scss';
import RequestQuoteHeader from './RequestQuoteHeader';
import { HeaderProps } from '@/types/header.types';

const Header: NextPage<HeaderProps> = ({ className = '' }) => {
  return (
    <header className={[styles.header, className].join(' ')}>
      <div className="container">
        <RequestQuoteHeader state="Desktop" />
      </div>
    </header>
  );
};

export default Header;
